import { FilterMatchMode, FilterService } from "primereact/api";
import { Column, ColumnEvent } from "primereact/column";
import { PositiveItem } from "../types/positiveItem";
import { PositiveItemTableActionsBody } from "../components/PositiveItem/PositiveItemTableActionsBody";
import { GradingAreaFilter } from "../components/Shared/GradingAreaFilter";
import { GradingAreaBody } from "../components/Shared/GradingAreaBody";
import { PhotoFolderBody } from "../components/Shared/PhotoFolderBody";
import { PositiveItemIdBody } from "../components/PositiveItem/PositiveItemIdBody";
import { InputTextareaEditor } from "../components/Shared/InputTextareaEditor";
import { PositiveItemTableImagesBody } from "../components/PositiveItem/PositiveItemTableImagesBody";

export const defaultPositiveItemFilters = {
    global: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS
    },
    id: {
        value: null,
        matchMode: FilterMatchMode.CUSTOM
    },
    description: {
        value: null,
        matchMode: FilterMatchMode.CONTAINS
    },
    gradingArea: {
        value: null,
        matchMode: FilterMatchMode.CUSTOM
    }
};

export const defaultPositiveItemColumns = (
    onCellEditComplete: (event: ColumnEvent) => void,
    inspectionDisabled: boolean
) => [
    <Column key="Delete" field="Delete" frozen selectionMode="multiple" />,
    <Column
        key="id"
        field="id"
        header="Id"
        frozen
        filter
        filterPlaceholder="Search by Id"
        sortable
        className="small-column"
        body={PositiveItemIdBody}
        showFilterMenu={false}
    />,
    <Column
        key="description"
        field="description"
        header="Description"
        className="small-column"
        editor={inspectionDisabled ? undefined : InputTextareaEditor}
        onCellEditComplete={onCellEditComplete}
    />,
    <Column
        key="gradingArea"
        field="gradingArea"
        header="Grading Area"
        filter
        sortable
        className="small-column"
        body={GradingAreaBody}
        filterElement={GradingAreaFilter}
        showFilterMenu={false}
    />,
    <Column
        key="photoFolder"
        field="photoFolder"
        header="Photo Folder"
        sortable
        className="small-column"
        body={PhotoFolderBody}
    />,
    <Column
        key="positiveItemsImages"
        header="Images"
        body={PositiveItemTableImagesBody}
    />,
    <Column
        key="positiveItemsActions"
        header="Actions"
        body={PositiveItemTableActionsBody}
    />
];

FilterService.register("custom_id", (value, filter) => {
    if (!filter || filter.length === 0) {
        return true;
    }

    return value.toString().includes(filter.replaceAll("-", ""));
});

export const getPositiveItemEditableFields = () => {
    const fields = ["description", "gradingArea", "photoFolder"];

    return fields;
};

export const createDefaultPositiveItem = (inspectionId: string) => {
    const positiveItem: PositiveItem = {
        id: 0,
        description: null,
        gradingArea: "",
        images: null,
        inspectionId,
        photoFolder: null
    };

    return positiveItem;
};
